import React, { Component } from 'react';
import './App.css';
import Flexbox from 'flexbox-react';
import pixr02 from './imgs/pixr02.jpg'
import vcbc1 from './imgs/vcbc1.jpg'
import traffic from './imgs/traffic.jpg'
import rt from './imgs/rt.jpg'
import cv from './imgs/macaldo_resume_01_20_2019.pdf'
import plate from './imgs/plate.gif'

class App extends Component {
  constructor(props) {
   super(props);
   this.aboutClick = this.aboutClick.bind(this);
   this.mainClick = this.mainClick.bind(this);
   this.updateDimensions = this.updateDimensions.bind(this);

   this.state =
     {
       main: true,
       about: false,
       width: window.innerWidth,
       isSkinny: false
     };
  }

  aboutClick() {
    this.setState({ about: true, main: false });
  }

 mainClick() {
   this.setState({ about: false, main: true });
 }

  updateDimensions(){
   this.setState({width: window.innerWidth})
   if (this.state.width < 1096) {
     this.setState({isSkinny: true})
   } else {
     this.setState({isSkinny: false})
   }

  }

 componentWillMount(){
   if (window.innerWidth < 1096) {
     this.setState({isSkinny: true})
   }
 }

  componentDidMount() {
    window.addEventListener('resize', this.updateDimensions)
  }

  render() {
    return (
      <div className="App">
        <Flexbox style={styles.mainFlex}>

          <div style={this.state.isSkinny? styles.navSkinny : styles.nav}>
            <hr style={styles.hr} />

            <div>
              <div>
                <div style={this.state.isSkinny? styles.logoSkinny: styles.logo}>
                  JOVEN <br />
                <div style={this.state.skinny? styles.lastnameSkinny: styles.lastname}>MACALDO</div>
                </div>
                <p style={styles.tag}>FULL-STACK WEB DEVELOPER</p>
              </div>
            </div>



            {this.state.isSkinny &&
              <div style={styles.skinnyNav}>
                <a onClick={this.aboutClick} style={styles.link}>ABOUT</a>  {' | '}
                <a onClick={this.mainClick} style={styles.link}>PAST PROJECTS</a>  {' | '}
                <a style={styles.link} href="mailto:jmacaldo@me.com">MAIL</a>  {' | '}
                <a style={styles.link} href={cv}>DOWNLOAD CV</a>  {' | '}
                <a style={styles.link} target="_blank" href="https://github.com/jmacaldo" rel="noopener noreferrer">GITHUB</a>  {' | '}
                <a style={styles.link} target="_blank" href="http://www.linkedin.com/in/jovenmacaldo" rel="noopener noreferrer">LINKEDIN</a>  {' | '}
                <a style={styles.link} target="_blank" href="https://www.instagram.com/jovenmacaldo/" rel="noopener noreferrer">INSTAGRAM</a>
              </div>

            }

            <ul style={this.state.isSkinny? styles.ulSkinny : styles.ul}>
              <li onClick={this.aboutClick} style={styles.link}>ABOUT</li>
              <li onClick={this.mainClick} style={styles.link}>PAST PROJECTS</li>
              <li><a style={styles.link}  href="mailto:jmacaldo@me.com">MAIL</a></li>
              <li><a style={styles.link}  href={cv}>DOWNLOAD CV</a></li>
              <li><a style={styles.link} target="_blank" href="https://github.com/jmacaldo" rel="noopener noreferrer">GITHUB</a></li>
              <li><a style={styles.link} target="_blank" href="http://www.linkedin.com/in/jovenmacaldo" rel="noopener noreferrer">LINKEDIN</a></li>
              <li><a style={styles.link} target="_blank" href="https://www.instagram.com/jovenmacaldo/" rel="noopener noreferrer">INSTAGRAM</a></li>
            </ul>
          </div>

          <div style={styles.content}>
            <hr style={this.state.isSkinny? styles.hrSkinny : styles.hr} />
            <div style={styles.projects}>


            {this.state.main &&
              <div>
                <h3>PAST PROJECTS</h3>
                <a target="_blank" rel="noopener noreferrer" href="http://jmacaldo.com/traffic"><img alt="" style={styles.img} src={plate} /></a>
               <Flexbox style={styles.flexcontainer}>
                 <div>
                   <h3>PROJECT NAME</h3>
                   <h5 style={styles.value}>NYC Traffic Ticket Scanner (iOS)</h5>
                   <h3>LINKS</h3>
                   <h5 style={styles.value}><a target="_blank" rel="noopener noreferrer" href="https://github.com/jmacaldo/nycplatescan">SOURCE</a></h5>
                 </div>
                 <div style={styles.right}>
                   <h3>TECHNOLOGIES</h3>
                   <h5 style={styles.value}>React, React Native, JavaScript, openALPR, Node.Js, RESTful API</h5>
                   <h3>DESCRIPTION</h3>
                   <h5 style={styles.value}>This is the iOS equivalent of the NYC Traffic Ticket Search web app, and it is built with React Native. This application uses the iPhone's camera to visually scan and recognize license plate numbers. Like its web counterpart, it returns all associated parking and trafic violations. The app is still in its very early stage of development</h5>
                 </div>
               </Flexbox>

                 <a target="_blank" rel="noopener noreferrer" href="http://jmacaldo.com/traffic"><img alt="" style={styles.img} src={traffic} /></a>
                <Flexbox style={styles.flexcontainer}>
                  <div>
                    <h3>PROJECT NAME</h3>
                    <h5 style={styles.value}>NYC Traffic Ticket Search</h5>
                    <h3>LINKS</h3>
                    <h5 style={styles.value}><a target="_blank" rel="noopener noreferrer" href="http://jmacaldo.com/traffic">LIVE DEMO</a></h5>
                  </div>
                  <div style={styles.right}>
                    <h3>TECHNOLOGIES</h3>
                    <h5 style={styles.value}>HTML5, CSS, JavaScript, Node.Js, PostgreSQL, Squelize, RESTful API</h5>
                    <h3>DESCRIPTION</h3>
                    <h5 style={styles.value}>NYC Traffic Ticket Search allows a user to enter a vehicle’s license plate, and the app returns all tickets and traffic violations associated with that plate. The app utilizes an API provided by NYC Open Data initiative.</h5>
                  </div>
                </Flexbox>

                <a target="_blank" rel="noopener noreferrer" href="https://pixr0.herokuapp.com/"><img alt="" style={styles.img} src={pixr02} /></a>
                <Flexbox style={styles.flexcontainer}>
                  <div>
                    <h3>PROJECT NAME</h3>
                    <h5 style={styles.value}>PIXR</h5>
                    <h3>LINKS</h3>
                    <h5 style={styles.value}><a target="_blank" rel="noopener noreferrer" href="https://pixr0.herokuapp.com/">LIVE DEMO</a></h5>
                    <h5 style={styles.value}><a target="_blank" rel="noopener noreferrer" href="https://github.com/Pixr0/pixr">SOURCE</a></h5>
                  </div>
                  <div style={styles.right}>
                    <h3>TECHNOLOGIES</h3>
                    <h5 style={styles.value}>HTML5, CSS, JavaScript, Node.Js, PostgreSQL, EJS, Squelize, Passport.Js</h5>
                    <h3>DESCRIPTION</h3>
                    <h5 style={styles.value}>Pixr is a project that I have done while in coding bootcamp. This project demonstrates skills in database management, user authentication, responsive design, and the use of the EJS templating engine.  Pixr is an Instagram-like web app where users can share and comment on photos.  </h5>
                  </div>
                </Flexbox>


                <a target="_blank" rel="noopener noreferrer" href="https://vcbc.herokuapp.com/"><img alt="" style={styles.img} src={vcbc1} /></a>
                <Flexbox style={styles.flexcontainer}>
                  <div>
                    <h3>PROJECT NAME</h3>
                    <h5 style={styles.value}>VEGAN COOK BOOK CLUB</h5>
                    <h3>LINKS</h3>
                    <h5 style={styles.value}><a target="_blank" rel="noopener noreferrer" href="https://vcbc.herokuapp.com/">LIVE DEMO</a></h5>
                    <h5 style={styles.value}><a target="_blank" rel="noopener noreferrer" href="https://github.com/jmacaldo/vcbc">SOURCE</a></h5>
                  </div>
                  <div style={styles.right}>
                    <h3>TECHNOLOGIES</h3>
                    <h5 style={styles.value}>HTML, CSS, JavaScript, Node.Js, PostgreSQL, Squelize, React-Redux, RESTful APIs </h5>
                    <h3>DESCRIPTION</h3>
                    <h5 style={styles.value}>
                      VCBC is a web app that allows users to share and rate their favorite plant-based recipes. I have solely built this project from the ground up. Main features include: user authentication, API-powered aggregated search, and the ability to rate and comment on recipes.
                    </h5>
                  </div>
                </Flexbox>

                <a target="_blank" rel="noopener noreferrer" href="http://omdbnycda.herokuapp.com/"><img alt="" style={styles.img} src={rt} /></a>
                <Flexbox style={styles.flexcontainer}>
                  <div>
                    <h3>PROJECT NAME</h3>
                    <h5 style={styles.value}>OMDB SEARCH APP</h5>
                    <h3>LINKS</h3>
                    <h5 style={styles.value}><a target="_blank" rel="noopener noreferrer" href="http://omdbnycda.herokuapp.com/">LIVE DEMO</a></h5>
                    <h5 style={styles.value}><a target="_blank" rel="noopener noreferrer" href="https://github.com/RottenTomatoesBoard/master">SOURCE</a></h5>
                  </div>
                  <div style={styles.right}>
                    <h3>TECHNOLOGIES</h3>
                    <h5 style={styles.value}>HTML, CSS, JavaScript, Node.Js, PostgreSQL, Squelize, React-Redux, RESTful APIs </h5>
                    <h3>DESCRIPTION</h3>
                    <h5 style={styles.value}>
                      This is a movie search app that uses the OMDB api as its search backend. This project was done in coordination with two other developers. I was personally responsible for the comments section and the deployment of the of the app.
                    </h5>
                  </div>
                </Flexbox>
              </div>
            }
            {this.state.about &&
              <div>
                <h3>ABOUT ME</h3>

                <Flexbox style={styles.aboutColumns}>
                  <div>
                    <h5 style={styles.aboutLeft}>
                      <p>
                        Hi! I’m Joven Macaldo - a web developer and former photographer who brings with him a  strong aesthetic sense to web development. I’m a tinkerer since childhood who loves to take things apart to find out how they work. I still do the same thing today, but only now with websites.
                      </p>

                      <p>
                        I consider the browser’s window as akin to a camera’s viewfinder - with divs and other elements as its subjects. Unlike a photograph however, websites are not a static medium. Subjects move. Even the size and shape of the very canvas the work exists in changes. To me, therein lies the excitement and challenge of web development in 2018. I believe that websites should not only function well, but also look great no matter the medium.
                       </p>

                       <p>
                           I am well versed in HTML5, CSS, JavaScript, and React. Although a currently a junior developer, I consider myself a quick study, and I relish the process of learning new technologies to solve problems.
                       </p>

                       <p>
                           When not pushing code, I enjoy some competitive cycling on the weekends. Check out my racing team <a target="_blank"  rel="noopener noreferrer" href="http://www.verrazanocycles.com/team/index.html">HERE</a>. I live in Brooklyn, NY with my wife Martina and a cat named Janek.
                       </p>


                    </h5>
                  </div>
                  <div>
                    <h5 style={styles.aboutContainer}>





                    </h5>
                  </div>
                </Flexbox>
              </div>
            }
            </div>
          </div>

        </Flexbox>

      </div>
    );
  }
}



const styles = {
  nav: {
    maxWidth: 300,
    flex: '1 2',
    paddingTop: 50,
    paddingLeft: 50,

  },
  navSkinny: {
    flex: '1 2',
    paddingTop: 50,
    paddingLeft: 50,
    maxWidth: 700,
    paddingRight: 50
  },
  logo: {
    fontSize: 50
  },
  logoSkinny: {
    fontSize: 30
  },
  hrSkinny: {
    display: 'none'
  },
  lastname: {
    color: "#808080",
    marginTop: -10
  },
  lastnameSkinny: {
    color: "#808080",
    marginTop: 110
  },
  headshot: {
    width: 100
  },
  tag: {
    fontSize: 20,
    marginTop: 0
  },
  projects: {
    display: 'flex',
    flexDirection: 'column',
  },
  value: {
    marginTop: -20
  },
  right: {
    paddingLeft: 30
  },

  content: {
    paddingTop: 50,
    paddingLeft: 50,
    maxWidth: 700,
    paddingRight: 50,
    flexShrink: 1
  },
  skinnyNav: {
    color: "#808080",
    fontSize: 15
  },
  regNav: {
    backgroundColor: "blue"
  },
  link: {
    textDecoration: "none",
    color: "#808080",
    cursor:'pointer',
    ":hover": {
      color: "blue"
    }
  },
  aboutContainer:{

  },

  aboutColumns: {

  },
  ul: {
    listStyleType: "none",
    marginLeft: -35,
    marginTop: 40,
    color: "#808080",
    textDecoration: "none"
  },
  ulSkinny: {
    display: "none"
  },
  mainFlex: {
    display: 'flex',
    flexWrap: "wrap"

  },
  container: {
    display: 'flex',
},
gfy: {
  position:'relative',
  paddingBottom:'54%'
},
gfyframe: {
  position:'absolute',
  top:0,
  left:0,
},
flexcontainer: {
  marginBottom: 50,
  width: '80%'
},
aboutLeft: {
  paddingRight: 20,
  maxWidth: '90%',
  lineHeight: 2
},
inner: {
  flex: '0 1 auto',
  display: 'flex',
  position: 'absolute',
  width: 860,
  justifyContent: 'center',
},
img: {
  flex: '0 1 auto',
  width: '100%',
  boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)"
},
  hr: {
    border: 0,
    height: 0,
    borderTop: "1px solid rgba(0, 0, 0, 1)",
    borderBottom: "1px solid rgba(255, 255, 255, 1)",
    color: '#fff'
}
}


export default App;



// WEBPACK FOOTER //
// ./src/App.js